<template>
  <div>
    <label v-if="label" class="input-label" :class="{ regular: regularLabel }">
      {{ label }}
    </label>
    <div
      class="custom-datetime-picker-container"
      :class="[classContainer, error ? 'invalidated' : '']"
    >
      <i :class="getCalendarIcon"></i>
      <span>
        <datepicker
          :class="'custom-date'"
          @input="updateValue"
          @selected="onSelectedDate"
          :bootstrap-styling="true"
          :language="es"
          :full-month-name="true"
          :monday-first="true"
          :calendar-class="{ 'custom-datetime-picker': true, right }"
          :format="format"
          :placeholder="placeholder"
          :value="value"
          :use-utc="useUtc"
          :disabled-dates="disabledDates"
          :disabled="isDisabled"
          :required="required"
          @keypress="$emit('keypress', $event)"
          :clear-button="isClearEnabled"
          clear-button-icon="fa fa-times prevent-close-dialog"
          @cleared="cleared"
        >
          <template>
            <input
              :required="required"
              :value="value"
              @input="$emit('input', value)"
              @keypress="$emit('keypress', $event)"
            />
          </template>
        </datepicker>
      </span>
    </div>
    <error v-if="error" variant="no-border" :message="customErrorMsg" />
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/dist/locale';
import Error from '@/components/common/Error';
export default {
  name: 'CustomDatePicker',
  meta: {
    description: 'Componente común de selector de fecha personalizado',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Datepicker,
    Error,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de referencia para el DatePicker',
        example: 'Texto requerido',
      },
    },
    maxDate: {
      type: Date,
      default: null,
      meta: {
        description: 'Estable un límite máximo para la fecha ',
        example: 'Texto requerido',
      },
    },
    minDate: {
      type: Date,
      default: null,
      meta: {
        description: 'Estable un límite mínimo para la fecha ',
        example: 'Texto requerido',
      },
    },
    format: {
      type: String,
      default: function() {
        return 'dd/MMM/yyyy';
      },
      meta: {
        description: 'Establece el formato de fecha en día, mes y año',
        example: 'Texto requerido',
      },
    },
    value: {
      type: Date,
      default: null,
      meta: {
        description: 'Parámetro de entrada del DatePicker',
        example: 'Texto requerido',
      },
    },
    disabled: {
      type: Boolean,
      default: function() {
        return undefined;
      },
      meta: {
        description: 'Estado deshabilitado',
        example: 'isDisabled',
      },
    },
    label: {
      type: String,
      default: '',
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      },
    },
    required: {
      type: String,
      default: function() {
        return '';
      },
      meta: {
        description: 'Estado requerido',
        example: 'Texto requerido',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    right: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Posicionamiento a la derecha',
        example: 'true',
      },
    },
    classContainer: {
      type: String,
      default: 'width-container',
      meta: {
        description: 'Agrega el selector de fecha a un elemento específico',
        example: 'Texto requerido',
      },
    },
    regularLabel: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Control para mostrar texto en regular',
        example: 'true',
      },
    },
    useUtc: {
      type: Boolean,
      default: () => true,
    },
    disabledDays: {
      type: Array,
      default: () => null,
      meta: {
        description: 'Deshabilita días de la semana del calendario',
        example: [6, 0], //Deshabilita sábado y domingo
      },
    },
  },
  data() {
    return {
      es: es,
    };
  },
  computed: {
    disabledDates() {
      var result = {
        from: this.maxDate ? new Date(this.maxDate) : null,
        to: this.minDate ? new Date(this.minDate) : null,
      };
      if (this.disabledDays !== null) {
        result.days = [6, 0];
      }
      return result;
    },
    isDisabled() {
      const disabled =
        this.disabled !== undefined &&
        this.disabled !== null &&
        this.disabled !== false;
      return disabled;
    },
    isClearEnabled() {
      return this.isDisabled ? false : true;
    },
    getCalendarIcon() {
      return this.disabled ? 'fa fa-calendar' : 'fa fa-calendar-day';
    },
  },
  methods: {
    onSelectedDate(e) {
      if (e) {
        e = new Date(e - e.getTimezoneOffset() * -60000);
        this.$emit('onSelectedDate', e);
      } else {
        this.$emit('onSelectedDate', null);
      }
    },
    updateValue(value) {
      if (value) {
        value = new Date(value - value.getTimezoneOffset() * -60000);
        this.$emit('input', value);
      } else {
        this.$emit('input', null);
      }
    },
    cleared() {
      this.$emit('cleared');
    },
  },
};
</script>

<style scope>
.input-label {
  height: 19px;
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  line-height: 19px;
}
.input-label.regular {
  font-weight: 400;
}
span.invalid:not(input) {
  color: #e85c5c;
}

.width-container {
  width: 192px !important;
}

.invalidated.custom-datetime-picker-container input[type='text'] {
  background-color: #f7d7da;
}

.custom-datetime-picker-container input[type='text'] {
  background: #fff;
  padding-left: 34px;
  text-align: left;
  font: Regular 16px/24px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}

.custom-datetime-picker-container-grey input[type='text'] {
  background: #f2f2f2;
  border: 1px solid #ced4da;
  border-radius: 4px;
  height: 36px;
  padding: 4px;
  width: 173px;
  text-align: center;
  padding-left: 27px;
}

.custom-datetime-picker-container i {
  color: #ff7058;
  position: absolute;
  margin-top: 11px;
  margin-left: 11px;
  z-index: 10;
}

.custom-datetime-picker-container i.prevent-close-dialog {
  margin-top: 13px;
}

.custom-datetime-picker-container.invalidated i {
  color: #ff5b5c;
}

.custom-datetime-picker-container span.cell.day {
  text-align: center;
  font: Bold 13px/20px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
  line-height: 35px;
}

.custom-datetime-picker-container span.cell.day.selected {
  background: #ff7058;
  color: #fff;
  border-radius: 50%;
}

.custom-datetime-picker-container header {
  padding: 10px;
  margin-bottom: 36px;
}

.custom-datetime-picker-container header > span.prev {
  background: #f8f8f8;
  border-radius: 50%;
  margin-top: -7px;
  text-indent: unset;
}

.custom-datetime-picker-container header > span.prev:after {
  border-right: none;
}

.custom-datetime-picker-container header > span.next {
  background: #f8f8f8;
  border-radius: 50%;
  margin-top: -7px;
  text-indent: unset;
}

.custom-datetime-picker-container header > span.next:after {
  border-left: none;
}

.custom-datetime-picker-container header + div {
  padding: 0px 10px 10px 10px;
  margin-top: 1px;
}

.custom-datetime-picker-container .day-header {
  background: #f8f8f8;
  font: Bold 13px/20px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
  margin-bottom: 10px;
  line-height: 35px;
}

.custom-datetime-picker-container .cell {
  font: Bold 13px/20px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}

.custom-datetime-picker-container .cell.selected {
  font: Bold 13px/35px Lato;
  color: #11291b;
  background: #ff7058;
  color: #fff;
}

.custom-datetime-picker {
  background: #fff;
  position: relative;
  border-radius: 5px;
}

.custom-datetime-picker + div {
  padding: 0px 10px 10px 10px;
}

.custom-datetime-picker header .prev + span {
  background: transparent;
  font: Bold 13px/20px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}

.custom-datetime-picker .cell:not(.blank):not(.disabled).day:hover {
  border: 1px solid #ff7058;
}

.custom-datetime-picker .cell:not(.blank):not(.disabled).month:hover {
  border: 1px solid #ff7058;
}

.custom-datetime-picker .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #ff7058;
}
.custom-datetime-picker-container input[type='text']:disabled {
  background: #e9ecef;
}
.right {
  right: 0 !important;
}

.custom-datetime-picker-container
  .input-group
  > .form-control:not(:last-child) {
  border-bottom-right-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.custom-datetime-picker-container .vdp-datepicker__clear-button {
  margin-left: 0px;
}

.custom-datetime-picker-container
  .vdp-datepicker__clear-button
  .input-group-text {
  padding: 0px;
  background: #fff;
  border: none;
  position: absolute;
  top: 6px;
  right: 32px;
}

.custom-datetime-picker-container .vdp-datepicker__clear-button i:before {
  font-size: 15px;
  color: #9d9d9d;
}
.custom-date > .input-group > .form-control {
  border: 1px solid rgba(60, 60, 60, 0.26);
}
</style>
